import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#info_svg__a)">
      <path
        fill="#263E6A"
        d="M11.5 16.5h1V11h-1zm.5-6.923q.261 0 .438-.177a.6.6 0 0 0 .177-.438.6.6 0 0 0-.177-.439.6.6 0 0 0-.438-.177.6.6 0 0 0-.438.177.6.6 0 0 0-.177.439q0 .261.177.438a.6.6 0 0 0 .438.177M12.003 21a8.8 8.8 0 0 1-3.51-.709 9.1 9.1 0 0 1-2.859-1.922 9.1 9.1 0 0 1-1.925-2.857A8.75 8.75 0 0 1 3 12.003q0-1.866.708-3.51a9.1 9.1 0 0 1 1.924-2.859 9.1 9.1 0 0 1 2.856-1.925A8.75 8.75 0 0 1 11.997 3q1.866 0 3.51.708a9.1 9.1 0 0 1 2.859 1.924 9.1 9.1 0 0 1 1.925 2.856A8.75 8.75 0 0 1 21 11.997a8.8 8.8 0 0 1-.709 3.51 9.1 9.1 0 0 1-1.922 2.859 9.1 9.1 0 0 1-2.857 1.925 8.75 8.75 0 0 1-3.509.709M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
      />
    </g>
    <defs>
      <clipPath id="info_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInfo;
